import React from 'react'
import Link from 'gatsby-link'

export { default } from './cv'

// const IndexPage = () => (
//   <div>
//     <h1>Hi people</h1>
//     <p>Welcome to your new Gatsby site.</p>
//     <p>Now go build something great.</p>
//     <Link to="/cv/">Go cv</Link>
//   </div>
// )

// export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js